import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Modal, TextField, FormControlLabel, Switch } from '@mui/material';
import { useDomain } from '../../context/DomainContext.js'

function KeywordModal({ openModal, selectedKeyword, handleCloseModal, handleSaveKeyword }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isRequired, setIsRequired] = useState(true);
  const [isNewKeyword, setIsNewKeyword] = useState(false);
  const [error, setError] = useState(false);
  const { selectedDomain } = useDomain();
  
  useEffect(() => {
    if (selectedKeyword?.name) {
      const data = {
        name: selectedKeyword.name,
        description: selectedKeyword.description.toLowerCase(),
        is_required: !!selectedKeyword.is_required,
      };
      setName(data.name);
      setDescription(data.description);
      setIsRequired(data.is_required);
      setIsNewKeyword(false);
    } else {
      setName('');
      setDescription('');
      setIsRequired(true);
      setIsNewKeyword(true);
    }
  }, [selectedKeyword]);

  const handleRequiredChange = (event) => {
    setIsRequired(event.target.checked);
  };

  const handleNameChange = (e) => {
    const inputValue = e.target.value;
  
    const isPartialValid = /^[a-zA-Z-_]*$/.test(inputValue);
  
    const isFinalValid = /^[a-zA-Z]+([-_]?[a-zA-Z]+)*$/.test(inputValue);
  
    if (isPartialValid) {
      setName(inputValue);
      setError(!isFinalValid);
    }
  };
  
  const handleInputChange = (setter) => (event) => {
    setter(event.target.value);
  };

  const handleSave = () => {
    const keywordData = {
      name: name,
      description,
      is_required: isRequired,
      domain_id: selectedDomain,
    };
    handleSaveKeyword(keywordData, isNewKeyword);
  };

  return (
    <>
      <Modal open={openModal} onClose={handleCloseModal} data-testid="keyword-modal">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxHeight: '80vh',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            overflow: 'auto',
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            {isNewKeyword ? 'Crear palabra clave' : 'Editar palabra clave'}
          </Typography>
          <TextField
            slotProps={{ htmlInput: { 'data-testid': 'keyword-modal-name-label' }}}
            fullWidth
            label="Nombre"
            variant="outlined"
            margin="normal"
            value={name}
            onChange={handleNameChange}
            error={error}
            helperText={error ? "Solo letras, números, guiones y guiones bajos permitidos" : ""}
          />
          <TextField
            fullWidth
            label="Descripción"
            variant="outlined"
            margin="normal"
            value={description}
            onChange={handleInputChange(setDescription)}
          />
          <FormControlLabel
            style={{ width: '100%', marginBottom: '8px' }}
            control={<Switch checked={isRequired} onChange={handleRequiredChange} />}
            label="Palabra clave requerida"
          />
          <Button disabled={!error && !description} variant="contained" onClick={handleSave} sx={{ mt: 1, mr: 2 }}>
            Guardar Cambios
          </Button>
          <Button variant="outlined" onClick={handleCloseModal} sx={{ mt: 1 }}>
            Cancelar
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default KeywordModal;
